

<div class="d-flex flex-row justify-content-between">
    <div class="pr-3 d-inline-block">
        <app-dialer-client-connection *ngIf="bTabSelected"></app-dialer-client-connection>
    </div>
    <div *ngIf="errorMsg" class="alert alert-danger d-inline-block">
        <div class="d-flex flex-row justify-content-between">
            <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
            {{errorMsg | shorten:200:'...'}}
            <div role="button" (click)="errorMsg=''"><i class="fa fa-times ml-2"></i></div>
        </div>
    </div>
</div>

<div class="d-flex flex-wrap justify-content-between pt-2 pr-2"
    *ngIf="dialerClientService.dialerService.bInitialized; else connectDialerButton">

    <dialer-config #dialerConfig class="pb-2 pl-2 flex-grow-1">

    </dialer-config>

    <div class="d-flex flex-column pl-2 pb-2 justify-content-between">

        <div class="d-flex flex-column">
            <button class="btn btn-secondary btn-sm mb-1"
                [disabled]="processing || dialerConfigComponent?.runningTestId||!canTest" (click)="runSeq()">
                Run Seq (unlogged)
            </button>
            <button class="btn btn-secondary btn-sm mb-1" [disabled]="processing" (click)="addPhone()">
                Add Phone
            </button>
            <button class="btn btn-secondary btn-sm mb-1"
                [disabled]="processing" (click)="reconnectAll()">
                Reconnect All
            </button>
            <button class="btn btn-secondary btn-sm mb-1"
                (click)="reportIssue()">
                Report Issue
            </button>

            <dialer-call-set-profile #callSetProfileComponent [profile]="dialerClientService.dialerConfigService.defaultProfile" class="mt-4">

            </dialer-call-set-profile>
        </div>

        <div class="d-flex flex-column mt-4">
            <ng-container *ngIf="dialerConfig?.rootTest && dialerConfig.runningTestId;">
                <button *ngIf="(dialerConfig.rootTest.status == 'PAUSING' || dialerConfig.rootTest.status == 'PAUSED'); else notPaused"
                    (click)="resumeTest()" class="btn btn-secondary btn-sm mb-1"
                    [disabled]="processing || (dialerTestService.resumingTestId$|async)==dialerConfig.runningTestId">
                    <i class="fa mr-2"
                        [ngClass]="dialerConfig.runningTestId&&(dialerTestService.resumingTestId$|async)==dialerConfig.runningTestId?'fa-spinner fa-spin':'fa-play'">
                    </i>
                    Resume
                </button>
                <ng-template #notPaused>
                    <button
                        (click)="pauseTest()" class="btn btn-secondary btn-sm mb-1"
                        [disabled]="processing || !dialerConfig.rootTest.pausable || (dialerTestService.pausingTestId$|async)==dialerConfig.runningTestId">
                        <i class="fa mr-2"
                            [ngClass]="dialerConfig.runningTestId&&
                            (dialerTestService.pausingTestId$|async)==dialerConfig.runningTestId?
                            'fa-spinner fa-spin':'fa-pause'">
                        </i>
                        Pause
                    </button>
                </ng-template>
                <button (click)="stopTest()"
                        [disabled]="processing || (dialerTestService.stoppingTestId$|async)==dialerConfig.runningTestId"
                        class="btn btn-secondary btn-sm mb-1">
                    <i class="fa mr-2"
                        [ngClass]="dialerConfig.runningTestId&&
                        (dialerTestService.stoppingTestId$|async)==dialerConfig.runningTestId?
                        'fa-spinner fa-spin':'fa-stop'">
                    </i>
                    Stop
                </button>
            </ng-container>
            <dialer-result-status *ngIf="!processing && dialerConfig?.rootTest"
                class="mt-1" role="button"
                [status]="((dialerConfig.runningTestId&&(dialerTestService.pausingTestId$|async)==dialerConfig.runningTestId)&&'PAUSING')
                ||dialerConfig.rootTest.status"
                (click)="showTestResults(dialerConfig.rootTest)">
            </dialer-result-status>
            <div *ngIf="processing" class="text-center">
                <i class="fa fa-spinner fa-spin"></i>
            </div>
        </div>

    </div>

</div>

<ng-template #connectDialerButton>
    <button class="btn btn-secondary btn-sm m-1" (click)="enableDialer(!this.dialerClientService.dialerService.bInitialized)">
        {{this.dialerClientService.dialerService.bInitialized?'Disable':'Enable'}}
    </button>
</ng-template>

